import Trans from 'next-translate/Trans';
import useTranslation from 'next-translate/useTranslation';

import { Box, LinkTranslatedStyledAsLink, Typography } from '@core/component';
import { Translate } from '@core/constant';
import { useContextMediaQuery } from '@core/context';
import { EActionAttribute, EColor, ERouting, ETypographyVariant } from '@core/type';

import { LinkFAQProps } from '../interface-contact';

export const InfoSection = () => {
  const { isPhone } = useContextMediaQuery();
  const { t: tContact } = useTranslation(Translate.page.CONTACT);

  return (
    <Box marginTop={isPhone ? '40px' : '76px'} marginBottom={'30px'}>
      <Typography
        variant={ETypographyVariant.H2}
        as={EActionAttribute.H1}
        marginBottom={isPhone ? '24px' : '30px'}
      >
        {tContact('hereToHelp')}
      </Typography>
      <Typography variant={ETypographyVariant.BODY1} marginBottom={'16px'}>
        {tContact('ourCustomerService')}
      </Typography>
      <Typography variant={ETypographyVariant.BODY1} marginBottom={'24px'}>
        {tContact('workHours')}
      </Typography>
      <Typography variant={ETypographyVariant.BODY1}>
        <Trans
          i18nKey={`${Translate.page.CONTACT}:findTheAnswers`}
          components={{
            link: <LinkFAQ />,
          }}
        />
      </Typography>
    </Box>
  );
};

const LinkFAQ = ({ children }: LinkFAQProps) => {
  return (
    <LinkTranslatedStyledAsLink
      keyRoute={ERouting.FAQ}
      color={EColor.ACCENT}
      variant={ETypographyVariant.BODY1}
    >
      {children}
    </LinkTranslatedStyledAsLink>
  );
};
